module.exports = __webpack_public_path__ + "img/logo_edus.1be4c0ba.png";